import Modal from '@molecules/Modal/Modal';
import ShareIcon from '@svg/share.svg';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useState } from 'react';

import Button from '../../00-atoms/Button/Button';
import styles from './DetailHero.module.scss';

const MODAL_ID = 'share-pop-up';

function ShareButton({ title, text }) {
  const [showPopUp, setShowPopUp] = useState(false);
  const router = useRouter();
  const link = `${process.env.JOBS_ENVIRONMENT_URL}${router.asPath.replace(
    /^\//,
    ''
  )}`;

  const togglePopUp = () => {
    setShowPopUp(!showPopUp);
  };

  const share = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title,
          text,
          url: link,
        });
      } else {
        togglePopUp();
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
  };

  const copyLink = () => {
    navigator.clipboard.writeText(link);
  };

  return (
    <>
      <Button
        label="Deel vacature"
        variant="text"
        Icon={ShareIcon}
        iconLeft
        modifierClass="boldText"
        extraClasses={styles.sharedButton}
        onClick={share}
        noAnimation
      />
      <Modal
        id={MODAL_ID}
        modalModifier="copyModal"
        show={showPopUp}
        onClose={() => setShowPopUp(false)}
        title="Deel deze vacature:"
      >
        <div className={styles.urlField}>
          <input className={styles.link} value={link} readOnly />
          <Button label="Kopieer link" onClick={copyLink} size="small" />
        </div>
      </Modal>
    </>
  );
}

ShareButton.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
};

export default ShareButton;
